import Play from './PlayPage';

export default Play;
